<template>
  <div class="project-form-container">
    <el-form :model="projectForm" :rules="rules" ref="projectForm" label-width="100px" class="project-form">
      <el-form-item label="项目环境" prop="env">
        <el-select v-model="projectForm.env" placeholder="请选择项目区域">
          <el-option v-for="item in envList" :key="item.env" :label="item.label" :value="item.env"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目slug" prop="slug">
        <el-select v-model="projectForm.slug" placeholder="请选择medusa项目slug" clearable filterable remote :remote-method="getProjects" :loading="loading" @change="changeSlug">
          <el-option v-for="item in projectList" :key="item.slug" :label="`${item.project_name}（${item.slug}）`" :value="item.slug">
          </el-option>
        </el-select>
        <el-button icon="el-icon-circle-plus-outline" class="new-project-button" type="text" @click="handleNewProject">新增项目slug</el-button>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="projectForm.projectName" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="默认路径" prop="path">
        <el-input v-model="projectForm.path" placeholder="最好输入英文路径哦~">
          <template slot="prepend">/custom/</template>
          <template slot="append">/</template>
        </el-input>
      </el-form-item>
      <el-form-item label="项目描述" prop="projectDescript">
        <el-input type="textarea" :rows="4" v-model="projectForm.projectDescript" placeholder="来为自己的项目说点什么吧..."></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('projectForm')">立即创建</el-button>
        <el-button @click="resetForm('projectForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 对话框 -->
    <el-dialog :append-to-body='true' :close-on-click-modal="false" :close-on-press-escape="true" :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent">
      <component @getProjects="getProjects" :is="dialog.component" @close="destroyComponent" />
    </el-dialog>
  </div>
</template>

<script>
import { fileManageApi, medusaApi } from '@/api/index';
import { dialogMixin } from "@/common/mixins/";
import newSlug from "./newSlug.vue"
let validateProjectPath = (rule, value, callback) => {
  if (/^((\w|\-|\_)+)$/.test(value)) {
    callback()
  } else {
    callback(new Error(`项目默认路径必须为根目录，例如：/custom/xps/ 最好为项目英文名称`,))
  }
}
export default {
  mixins: [dialogMixin],
  props: {
    envList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      projectList: [],
      projectForm: {
        env: '',
        projectName: '',
        path: '',
        projectDescript: '',
        slug: ''
      },
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        env: [
          { required: true, message: '请选择项目环境', trigger: 'change' }
        ],
        slug: [
          { required: true, message: '请选择项目slug', trigger: 'change' }
        ],
        path: [
          { validator: validateProjectPath, required: true, trigger: 'blur' }
        ],
        projectDescript: [
          { required: true, message: '请输入项目描述', trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  mounted () {
    this.getProjects();
  },
  methods: {
    // 新增medusa项目
    handleNewProject () {
      this.setDialog(true, "新增美杜莎项目", newSlug, "600px", "25vh");
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 改变项目slug触发
    changeSlug (val) {
      const project = this.projectList.find(item => item.slug === val);
      this.projectForm.projectName = project ? project.project_name : '';
      this.projectForm.path = val;
    },
    // 获取项目列表
    getProjects (searchStr) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false;
        const res = await medusaApi.getProjects({ searchStr })
        if (res.code) {
          this.projectList = res.data;
        }
      }, 200);
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const path = `/custom/${this.projectForm.path}/`;
          const res = await fileManageApi.createProject({ ...this.projectForm, path });
          if (res.code === 200) {
            this.$message.success('创建成功！');
            this.$emit('close');
            this.$emit('getProjectList');
          } else {
            this.$message.error(res.message);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="scss" scoped>
.project-form-container {
  .project-form {
    .new-project-button {
      margin-left: 15px;
    }
  }
}
</style>